import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=e04505f4&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=e04505f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04505f4",
  null
  
)

export default component.exports